/**
 * Minimal UI Kit — Typography config
 * Source: https://github.com/minimal-ui-kit/material-kit-react (free kit, v6.x)
 *
 * Font: Public Sans (loaded via Google Fonts in each app's index.html)
 * All scale values are faithful to the Minimal free kit.
 */

export const FONT_PRIMARY = "'Public Sans', sans-serif";

function rem(px: number): string {
  return `${px / 16}rem`;
}

export const minimalTypography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    fontSize: rem(80),
    lineHeight: 100 / 80,
  },
  h2: {
    fontWeight: 800,
    fontSize: rem(64),
    lineHeight: 76 / 64,
  },
  h3: {
    fontWeight: 700,
    fontSize: rem(48),
    lineHeight: 64 / 48,
  },
  h4: {
    fontWeight: 700,
    fontSize: rem(32),
    lineHeight: 48 / 32,
  },
  h5: {
    fontWeight: 700,
    fontSize: rem(24),
    lineHeight: 36 / 24,
  },
  h6: {
    fontWeight: 700,
    fontSize: rem(18),
    lineHeight: 28 / 18,
  },
  subtitle1: {
    fontWeight: 600,
    fontSize: rem(16),
    lineHeight: 24 / 16,
  },
  subtitle2: {
    fontWeight: 600,
    fontSize: rem(14),
    lineHeight: 22 / 14,
  },
  body1: {
    fontWeight: 400,
    fontSize: rem(16),
    lineHeight: 24 / 16,
  },
  body2: {
    fontWeight: 400,
    fontSize: rem(14),
    lineHeight: 22 / 14,
  },
  caption: {
    fontWeight: 400,
    fontSize: rem(12),
    lineHeight: 20 / 12,
  },
  overline: {
    fontWeight: 700,
    fontSize: rem(12),
    lineHeight: 24 / 12,
    letterSpacing: "1.1px",
    textTransform: "uppercase" as const,
  },
  button: {
    fontWeight: 700,
    fontSize: rem(14),
    lineHeight: 24 / 14,
    textTransform: "unset" as const,
  },
} as const;
